import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg viewBox="0 0 444 263" {...props}>
      <g transform="matrix(-0.603825,-0.603825,0.603825,-0.603825,-5290.88,11680.4)">
        <path d="M5074.5,13845.5C5074.5,13845.5 5137,13879.9 5137,13924.5C5137,13959 5108.99,13987 5074.5,13987C5040.01,13987 5012,13959 5012,13924.5C5012,13879.9 5074.5,13845.5 5074.5,13845.5Z" />
      </g>
      <g transform="matrix(0.766564,-0.442576,0.442576,0.766564,-9638.51,-8272)">
        <path d="M4796.35,13671.2C4796.35,13628.2 4856.64,13595 4856.64,13595C4856.64,13595 4916.94,13628.2 4916.94,13671.2L4916.94,13867.3C4916.94,13900.6 4889.92,13927.6 4856.64,13927.6C4823.36,13927.6 4796.35,13900.6 4796.35,13867.3L4796.35,13671.2Z" />
      </g>
      <g transform="matrix(0.766564,-0.442576,0.442576,0.766564,-9469.69,-8272)">
        <path d="M4796.35,13671.2C4796.35,13628.2 4856.64,13595 4856.64,13595C4856.64,13595 4916.94,13628.2 4916.94,13671.2L4916.94,13867.3C4916.94,13900.6 4889.92,13927.6 4856.64,13927.6C4823.36,13927.6 4796.35,13900.6 4796.35,13867.3L4796.35,13671.2Z" />
      </g>
    </Svg>
  );
};

export default Icon;
